import React from 'react';
import type { BonusLevelPayload } from '../../../../constants/bonusConstants';
import { useTranslation } from '../../../../i18n';
import { getBonusIntro } from '../../../../i18n/helpers';
import { QuickMathHostProgressive } from './QuickMathHostProgressive';
import './quick-math.css';

interface QuickMathHostProps {
  payload: BonusLevelPayload;
  roundEnded: boolean;
}

/**
 * Casting host during play: title + expression building (first pair, then +op+number every 2s).
 * Intro copy lives in BonusIntro only — no extra hint here.
 */
export const QuickMathHost: React.FC<QuickMathHostProps> = ({ payload, roundEnded }) => {
  const { t } = useTranslation();
  const numbers = payload.numbers ?? [];
  const ops = (payload.ops ?? []) as ('+' | '-')[];

  const title = getBonusIntro('quick-math').title;

  if (!numbers.length || ops.length !== numbers.length - 1) {
    return (
      <div style={{ textAlign: 'center', padding: '1rem' }}>
        <h2 className="bonus-game-playing-title" style={{ color: 'var(--color-primary)' }}>
          {title}
        </h2>
        <p className="bonus-host-glow-text--muted">{t('bonus.host.loadingMath')}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 1 auto',
        minHeight: 0,
      }}
    >
      {!roundEnded && (
        <h2 className="bonus-game-playing-title" style={{ margin: '0 0 0.35rem', color: 'var(--color-primary)', flexShrink: 0 }}>
          {title}
        </h2>
      )}
      <QuickMathHostProgressive
        numbers={numbers}
        ops={ops}
        roundEnded={roundEnded}
        questionId={payload.questionId}
      />
    </div>
  );
};
